import React from "react";
import { Button, Result } from "antd";
import { Link, useLocation } from "react-router-dom";
import PageRoutes from "../../utils/routes";

const SuccessPage = () => {
  const location = useLocation();
  const { successTitle, successDetail } = location.state || {}; // Access successTitle and successDetail from location state

  const handleGoBack = () => {
    window.history.back();
  };
  return (
    <Result
      status="success"
      title={successTitle}
      subTitle={successDetail}
      extra={[
        <Button key="goBack" onClick={handleGoBack}>
          Geri Dön
        </Button>,
        <Link to={PageRoutes.home}>
          <Button type="primary">Ana Sayfa</Button>
        </Link>,
      ]}
    />
  );
};
export default SuccessPage;
